<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!recentAlerts.length" class="dw-empty">No alerts in the last {{ daysRange }} days.</div>
    <div v-else class="dw-table-wrap">
      <table class="dw-table">
        <thead>
          <tr>
            <th>Vehicle</th>
            <th>Alert Type</th>
            <th>Recipient</th>
            <th>Alert Time</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="alert in recentAlerts" :key="alert.key" @click="goToAlerts">
            <td :title="alert.vehicle || ''">{{ alert.vehicle || '–' }}</td>
            <td>{{ alert.typeLabel }}</td>
            <td :title="alert.recipient || ''">{{ alert.recipient || '–' }}</td>
            <td>{{ alert.timeLabel }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { alertTypeLabel } from '../../utils/alerts_analytics'

const MAX_ROWS = 5

export default {
  name: 'widget_recent_alerts',
  props: {
    // shared across every alert-detail widget by main_dashboard.vue's
    // load_alerts_detail(), so this widget costs no API call of its own.
    alerts: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    daysRange: { type: Number, required: true },
  },
  computed: {
    // columns mirror alert_list.vue's table field order (Vehicle, Alert
    // Type, ..., Recipient, ...), trimmed to what fits a compact widget.
    recentAlerts() {
      return this.alerts
        // only genuine alert types (LateAlert, VehicleActivityAlert,
        // DriverHOSAlert, etc.) -- excludes trip-status pings
        // (*TripNotification, RelayNotification) and other non-alert rows
        // this feed also carries (GroupMessage, SMSReceived, CustomerSurvey,
        // MissingDVIR, ...). Recent Alerts surfaces alert-proper rows only.
        .filter(item => String(item.alert_type || '').includes('Alert'))
        .sort((a, b) => new Date(b.processed_time) - new Date(a.processed_time))
        .slice(0, MAX_ROWS)
        .map(item => ({
          key: item.movement_vehicle_id || (item.alert_type + '-' + item.processed_time),
          vehicle: this.vehicleLabel(item.vehicle_id),
          typeLabel: alertTypeLabel(item.alert_type),
          recipient: item.sms_name || '',
          timeLabel: moment(item.processed_time).format('MM/DD h:mma'),
        }))
    },
  },
  methods: {
    // vehicle_id is the real vehicle identifier (alert_list.vue's own
    // "Vehicle" column source) -- unlike movement_vehicle_id, which is an
    // internal record key (e.g. "cust-trip-<booking_id>", see
    // fleet-int-api/util/generate_test_data.py) and never a vehicle name, so
    // it must NOT be used as a fallback here. Can be a comma-separated list
    // for multi-vehicle alerts, with literal "none" entries to drop --
    // mirrors alert_list.vue's vehicle_id template slot exactly.
    vehicleLabel(rawVehicleId) {
      const ids = String(rawVehicleId || '')
        .split(',')
        .map(s => s.trim())
        .filter(s => s && s.toLowerCase() !== 'none')
      return ids.join(', ')
    },
    goToAlerts() {
      this.$router.push({ name: 'alerts_dashboard' }).catch(() => {})
    },
  },
}
</script>
